export const GRANT_TYPE = 'password'
export const ACCESS_TOKEN_PASS = 'thailand4%0'
export const ACCESS_TOKEN_USER = 'devdee'


export const SHIPPER_COLOR_LIST = ["#ff7c4382","#3cacff87","#fff57799","#9cff6447","#eb4f4f63","#9d9ce947","#1eedda40","#874826ad","#fff81359","#ffffff40"];